module.exports = __webpack_public_path__ + "static/img/layout8.f2c1f1c3.png";